module.exports = __webpack_public_path__ + "media/images/flags/32/Uganda-b1e9396575e27c92e4a47117d5529bac.png";